import React from "react";

const HomeCard: React.FC = () => {
   return (
    <div className="container mx-auto px-4 py-10">
      <h2 className="text-3xl font-bold text-center mb-10">Values and services you can expect</h2>
      <div className="grid grid-cols-3 gap-6 items-center text-center max-w-5xl mx-auto">
        <div className="bg-white shadow-lg rounded-lg p-6">
          <h3 className="text-pink-600 font-semibold mb-4">Features</h3>
          <ul className="space-y-4">
            {[
              "eKYC for Tenants & Owners",
              "Online Rent Payment",
              "Real-Time Notifications",
              "Maintenance Requests",
              "Secure Living Environment",
              "Flexible Accommodation",
              "Transparent Costs",
            ].map((feature, index) => (
              <li key={index} className="text-gray-700">{feature}</li>
            ))}
          </ul>
        </div>

        <div className=" text-white rounded-lg  shadow-lg">
            <div className=" bg-gradient-to-b from-pink-500 to-pink-700 h-14">
            <h3 className=" w-full font-semibold pt-3 text-pink-100 font-serif text-2xl">ZOY</h3>

            </div>
          <ul className="space-y-4 p-6">
            {[
              "Mandatory for Secure Living",
              "Easy & Transparent Payments",
              "Instant Updates via App",
              "Managed via App",
              "Verified Tenants & Owners",
              "Shared & Private Spaces",
              "No Hidden Charges",
            ].map((feature, index) => (
              <li key={index} className="flex items-center gap-2 text-black">
                ✅ {feature}
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-white shadow-lg rounded-lg p-6">
          <h3 className="text-black font-semibold mb-4">Traditional PG's</h3>
          <ul className="space-y-4">
            {[
              "Rarely Done",
              "Manual Process",
              "No Notification System",
              "Dependent on PG Management",
              "No Verification Process",
              "Limited Options",
              "Broker Fees Apply",
            ].map((feature, index) => (
              <li key={index} className="flex items-center gap-2 text-black-500">
                ❌ {feature}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HomeCard;
